/**
 * Various modes the modal can be in
 *
 * @export
 * @enum {number}
 */
export enum ModalManagerMode {
  Open = 'open',
  Closed = 'closed',
}
